
import Voyawander from "../Utils/images/Voyawander.png";
import Healthcart from "../Utils/images/Healthcart.png";
import Apple from "../Utils/images/Apple.png";
import carver from "../Utils/images/carver.png"

export const projects = [
  {
    img: Apple,
    title: "Apple",
    des: "An Apple website clone is a meticulously designed and responsive platform that mirrors the aesthetics and functionality of Apple's official website. It offers users a seamless experience to explore and purchase Apple products.",
    demo: "",
    live: "https://apple-frontend-ir9fo5jtm-muskanthapa2000.vercel.app/",
    gitHub: "https://github.com/muskanthapa2000/apple.git",
    technologies: [
      "React",
      "CSS",
      "JavaScript",
      "Chakra-UI",
      "MongoDB",
      "Express",
      "Node JS",
    ],
  },
  {
    img: Healthcart,
    title: "HealthKart",
    des: "A Healthkart website clone is a meticulously crafted replica of the popular online health and wellness platform, offering an extensive range of nutritional supplements, fitness equipment, and wellness products.",
    demo: "",
    live: "https://graceful-speculoos-4458b2.netlify.app/index.html",
    gitHub: "https://github.com/Swagh001/HealthKart-Clone.git",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript", 
      "Localstorage"
    ],
  },
  {
    img: Voyawander,
    title: "Voyawander",
    des: "Voyawander is your gateway to global adventures. Discover and book international travel packages, exploring the world's most captivating destinations with ease and convenience.",
    demo: "",
    live: "https://travel-ifnuubrvm-muskanthapa2000.vercel.app/",
    gitHub: "https://github.com/muskanthapa2000/SoloTravelProject.git",
    technologies: ["HTML", "CSS", "JavaScript", "React", "Redux" ,"GitHub"],
  },
  {
    img: carver,
    title: " Carver skateboard",
    des: "A Carver clone is a skateboard website replica that emulates the style and features of the original. It offers a comparable skateboarding experience and showcases similar products and content.",
    demo: "",
    live: "https://carver-clone.netlify.app/",
    gitHub: "https://github.com/Rohit27698/carver_Clone.git",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript", 
      "Localstorage"
    ],
  }
];
